// src/components/AnimatedMascot/AnimatedMascot.jsx
import React, { useRef, useEffect } from "react";
import { Player } from "@lottiefiles/react-lottie-player";
import mascotData from "../../assets/Thumbs up birdie.json";

const AnimatedMascot = ({ trigger }) => {
  const player = useRef(null);

  useEffect(() => {
    if (!player.current) return;

    const lottie = player.current;

    // Käynnistä vain jos ei jo pyöri
    if (!lottie.isPlaying) {
      lottie.play();
    }
  }, [trigger]);

  return (
    <Player
      ref={player}
      autoplay={false}
      loop={false}
      src={mascotData}
      className="w-[400px] h-[800px] transition-all duration-500"
    />
  );
};

export default AnimatedMascot;

